// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  apiUrl: 'https://4s9xmk9m6d.execute-api.us-east-1.amazonaws.com'
  //apiUrl: 'http://172.22.2.13:'
  //apiUrl: 'http://localhost:8093'
  //apiUrl: "http://localhost:8086"
  //apiUrl: 'http://25.19.86.44:8086'
  //  apiUrl: 'http://192.168.1.200:'

  // NO OLVIDAR LOS 2 PUNTOS DESPUES DE LA IP .....
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts